import { useRef } from "react";

/**
 * Mantém a identidade do `rest` (props repassadas à raiz) enquanto os valores não mudam, para que o
 * ViewModel memoizado não recalcule a cada render só porque o JSX da tela criou um objeto novo.
 */
export function useStableRest<T extends object>(rest: T): T {
  const ref = useRef(rest);
  const previous = ref.current;
  const previousKeys = Object.keys(previous) as (keyof T)[];
  const sameShape =
    previousKeys.length === Object.keys(rest).length &&
    previousKeys.every((key) => Object.is(previous[key], rest[key]));
  if (!sameShape) ref.current = rest;
  return ref.current;
}
